import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatColumnDef, MatTable } from '@angular/material/table';
import { IModel } from '@klickdata/core/application';
import { SelectModelMatTableColumnApi } from './select-model-mat-table-column-api';

/**
 * Renders the standard `select` checkbox column for tables backed by
 * {@link SelectModelBaseDirective}. Registers {@link MatColumnDef} with
 * {@link MatTable#addColumnDef} because nested defs are not content children of
 * the table. Pass `[matTable]="yourMatTableTemplateRef"` from the parent template.
 *
 * Registration runs in `ngOnInit` with a static `MatColumnDef` query so the column
 * exists before `MatTable.ngAfterContentChecked` (that hook runs before any
 * `ngAfterViewInit` in the same change-detection pass).
 */
@Component({
    selector: 'app-select-model-mat-table-column',
    templateUrl: './select-model-mat-table-column.component.html',
    styleUrls: ['./select-model-mat-table-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectModelMatTableColumnComponent<T extends IModel> implements OnInit, OnDestroy {
    @Input() api!: SelectModelMatTableColumnApi<T>;
    /** Must be the {@link MatTable} instance for the enclosing `<mat-table>`. */
    @Input() matTable!: MatTable<unknown>;
    @ViewChild(MatColumnDef, { static: true }) columnDef!: MatColumnDef;

    private columnRegistered = false;

    ngOnInit(): void {
        if (!this.matTable || !this.columnDef) {
            return;
        }
        this.matTable.addColumnDef(this.columnDef);
        this.columnRegistered = true;
    }

    ngOnDestroy(): void {
        if (this.columnRegistered && this.matTable && this.columnDef) {
            this.matTable.removeColumnDef(this.columnDef);
        }
    }
}
